// extracted by mini-css-extract-plugin
module.exports = {"container":"PracticeMistakesView_container__37Wgu","content-container":"PracticeMistakesView_content-container__1wZ_v"};